import React from "react";
import { SiWindowsxp } from "react-icons/si";
import { FaApple } from "react-icons/fa";
import { TbDeviceIpad } from "react-icons/tb";
import { AiFillAndroid } from "react-icons/ai";
import { FaLinux } from "react-icons/fa6";
import { BsNintendoSwitch } from "react-icons/bs";

const useOsSystemIcons = () => {
  const getOsSystemIcon = (os, classNames) => {
    switch (os) {
      case "win":
      case "win64":
        return <SiWindowsxp className={classNames} />;
      case "macos":
        return <FaApple className={classNames} />;
      case "ios":
        return <TbDeviceIpad className={classNames} />;
      case "android":
        return <AiFillAndroid className={classNames} />;
      case "linux":
        return <FaLinux className={classNames} />;
      case "switch":
        return <BsNintendoSwitch className={classNames} />;
      default:
        return <></>;
    }
  };

  return { getOsSystemIcon };
};

export default useOsSystemIcons;
